import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useAuth } from "../AuthContext";

// After auth, send disputants/witnesses straight to their disputes list;
// everyone else lands on the new-dispute form. Mirrors Home.js's landingPathFor.
async function landingPathFor(authToken) {
  const API_BASE = process.env.REACT_APP_API_URL || "";
  try {
    const res = await fetch(`${API_BASE}/api/ai/disputes/mine`, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    if (!res.ok) return "/submit-dispute";
    const data = await res.json();
    const isParticipant = (data.disputes || []).some(
      (d) => d.role === "disputant" || d.role === "witness"
    );
    return isParticipant ? "/all-disputes" : "/submit-dispute";
  } catch {
    return "/submit-dispute";
  }
}

export default function VerifyEmail() {
  const { token } = useParams();
  const { verifyEmail } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [status, setStatus] = useState("verifying"); // verifying | failed
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; // the token is single-use — guard against a double effect run
    ranRef.current = true;

    (async () => {
      try {
        const data = await verifyEmail(token);
        navigate(await landingPathFor(data.token));
      } catch (err) {
        setStatus("failed");
        setError(err.message);
      }
    })();
  }, [token, verifyEmail, navigate]);

  return (
    <div style={styles.page}>
      <SiteHeader />
      <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Verify your email</h1>
        {status === "verifying" && <p style={styles.subtitle}>Verifying your account…</p>}
        {status === "failed" && (
          <>
            <p style={styles.error}>{error}</p>
            <div style={styles.footer}>
              <Link to="/login" style={styles.link}>Back to Login</Link>
            </div>
          </>
        )}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}

const styles = {
  // Same shell as every other public page: sticky SiteHeader, content that
  // grows, SiteFooter pinned to the bottom.
  page: {
    minHeight: "100vh", display: "flex", flexDirection: "column",
    background: "#F4F4F0",
  },
  container: {
    display: "flex", alignItems: "center", justifyContent: "center",
    flex: 1, padding: "32px 20px", fontFamily: "'JetBrains Mono', monospace"
  },
  card: {
    background: "white", padding: "40px", borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)", width: "100%", maxWidth: "400px",
    textAlign: "center"
  },
  title: { fontSize: "24px", fontWeight: "700", marginBottom: "8px" },
  subtitle: { fontSize: "14px", color: "#666", marginBottom: "0" },
  error: { color: "#ff4d4d", fontSize: "12px", margin: "0" },
  footer: { marginTop: "24px" },
  link: { color: "#7c6af7", fontSize: "12px", textDecoration: "none" }
};
